import React, { Component } from "react";
import "../../Assets/css/myaccount.css";
import {
  Breadcrumbs,
  CircularProgress,
  Dialog,
  List,
  Typography,
} from "@material-ui/core";
import {
  Col,
  Container,
  Row,
  ProgressBar,
  Modal,
  Form,
  Image,
} from "react-bootstrap";
import { SideBySideMagnifier } from "react-image-magnifiers";
import ImageGallery from "react-image-gallery";
import "../../Assets/css/productDetails.css";
import "../../../node_modules/react-image-gallery/styles/css/image-gallery.css";
import { TextField, Button, Rating, Skeleton } from "@mui/material";
import axios from "axios";
import {
  base_url,
  client_name,
  currencycode,
  isLogin,
  postHeader,
  user,
} from "../../Helpers/request";
import { toast } from "react-toastify";
import Videoimg from "../../Assets/images/example-360video-thumb.jpg";
import moment from "moment";
import {
  ProductAppoitnment,
  ProductEnquiry,
  ReturnModal,
  ShippingModal,
} from "../../Components/Modals";
import {
  FacebookShareButton,
  EmailShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from "react-share";
import { Helmet } from "react-helmet";
import Ringbildermenu from "../../Components/ringbildermenu";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { isMobileOnly, isTablet } from "react-device-detect";
import { NavLink } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import cart from "../../Assets/images/cart.png";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import inquir from "../../Assets/images/inquir.svg";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import Engraving from "../../Components/engraving";
import rose_metal from "../../Assets/images/icon/metal_rg.webp";
import yellow_metal from "../../Assets/images/icon/metal_yg.webp";
import white_metal from "../../Assets/images/icon/metal_wg.webp";
import { store } from "../../Store/store";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { sessionId } from "../../Reducer/homeReducer";
import { MdBrightness1 } from "react-icons/md";

class Productdetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilter: true,
      images: [],
      currentImageUrl: [],
      currentImagetype: null,
      currencies: [
        {
          value: "Round",
          label: "Round",
        },
        {
          value: "Round Cut",
          label: "Round Cut",
        },
        {
          value: "Round1",
          label: "Round1",
        },
        {
          value: "Round2",
          label: "Round2",
        },
      ],
      currency: false,
      value: "5",
      shipping: false,
      return: false,
      review: false,
      filterdata: [],
      productdetails: [],
      reviewdata: [],
      slug: decodeURIComponent(this.props.match.params.slug),
      rating: "",
      comment: "",
      ringSize: "",
      engravingshow: false,
      notify: false,
      ringSizeAvailable: false,
      loader: true,
      shippingterm: [],
      openbutton: false,
      inquiry: false,
      listdata: [],
      proindex: "",
      engraving: "",
      textstyle: "great_vibes",
      MetalColor: "",
    };
  }

  componentDidMount() {
    this.productdetails();
    this.filterApi();
    this.shippingterm();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.slug !== this.state.slug) {
      this.productdetails();
      this.filterApi();
    }
  }
  shippingterm = () => {
    axios
      .get(base_url + "/order/shipping_options", {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          this.setState({ shippingterm: res.data.data });
        } else {
          toast.error(res.data.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  filterApi = () => {
    const data = {
      currency_code: currencycode,
      slug: this.state.slug,
    };
    axios
      .post(base_url + "/product/productdetailfilter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          this.setState({ filterdata: res.data.data });
          res.data.data.map((val) => {
            if (val.title == "Ring Size") {
              this.setState({ ringSizeAvailable: true });
            }
          });
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  similarproduct = (prodata) => {
    const data = {
      currency_code: currencycode,
      product_id: prodata?.product_id,
      metal_color: prodata?.metal_color,
      category: prodata?.category_slug,
      user_id: user.user_id ? user.user_id : "",
      session_id: store.getState().persistedReducer.home.session_id,
    };
    axios
      .post(base_url + "/product/relatedproduct", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          this.setState({ listdata: res.data.data?.result });
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength(0));
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else {
          this.setState({ listdata: [] });
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  calculateDiscount = (original, discounted) => {
    const result = ((original - discounted) / original) * 100;
    return Math.round(result);
  };

  productdetails = () => {
    this.setState({ loader: true });
    const data = {
      currency_code: currencycode,
      slug: this.state.slug,
      selecteddata: this.state.filterdata,
      user_id: user.user_id ? user.user_id : "",
      session_id: store.getState().persistedReducer.home.session_id,
    };
    axios
      .post(base_url + "/product/productdetail", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          this.similarproduct(res.data.data[0]);
          if (this.props.match.params.id == "setting") {
            this.props.history.push(
              "/ringsettingdetail/setting/" + res.data.data[0].slug
            );
          } else {
            this.props.history.push("/productdetail/" + res.data.data[0].slug);
          }
          this.getReview(res.data.data[0]?.product_id);
          var arr = [];
          this.setState({
            MetalColor: res.data.data[0]?.metal_color,
            productdetails: res.data.data[0],
            currentImageUrl: res.data.data[0]?.product_image[0]?.url,
            currentImagetype: res.data.data[0]?.product_image[0]?.type,
            slug: res.data.data[0].slug,
          });
          res.data.data[0]?.product_image?.map((val) => {
            if (val.type == "2") {
              var obj = {
                original: val.url,
                thumbnail: Videoimg,
                originalAlt: res.data.data?.name,
                thumbnailAlt: res.data.data?.name,
                type: val.type,
              };
              arr.push(obj);
            } else if(val.type == "3"){
              var obj = {
                original: val.url,
                thumbnail: Videoimg,
                originalAlt: res.data.data?.name,
                thumbnailAlt: res.data.data?.name,
                type: val.type,
              };
              arr.push(obj);
            } else {
              var obj = {
                original: val.url,
                thumbnail: val.url,
                originalAlt: res.data.data?.name,
                thumbnailAlt: res.data.data?.name,
                type: val.type,
              };
              arr.push(obj);
            }
          });
          this.setState({ images: arr, loader: false });

          // this.filterApi();
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength());
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else {
          this.props.history.push("/page-not-found");
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addtowishlist = (product_id, wishindex, id) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: store.getState().persistedReducer.home.session_id,
      product_id: product_id,
      type: "JEWELRY",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          if (id) {
            const productlist = this.state.listdata.map((obj, index) =>
              index == wishindex
                ? Object.assign(obj, { is_wishlist: res.data.data.wishlist_id })
                : obj
            );
            this.setState({ listdata: productlist });
          } else {
            this.productdetails();
          }
          store.dispatch(whishlistlength(res.data.data.count));
          toast.success(res.message, { autoClose: 3000 });
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength());
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onchangeselect = (e, title) => {
    var changedata = [...this.state.filterdata];
    changedata = changedata.map((obj) =>
      obj.title == title
        ? Object.assign(obj, { selected: e.target.value })
        : obj
    );
    this.setState({ filterdata: changedata });
    this.productdetails();
  };
  getReview = (product_id) => {
    const data = {
      currency_code: currencycode,
      product_id: product_id,
    };
    axios
      .post(base_url + "/product/reviews_list", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          this.setState({ reviewdata: response.data.data });
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  addtocart = (product_id, id) => {
    if (id == 1 && this.state.ringSize == 0 && this.state.ringSizeAvailable) {
      this.setState({ notify: true });
    } else {
      const data = {
        currency_code: currencycode,
        user_id: user.user_id ? user.user_id : "",
        session_id: store.getState().persistedReducer.home.session_id,
        product_id,
        quantity: "1",
        ring_size: this.state.ringSize,
        engraving_text: this.state.engraving,
        engraving_font: this.state.textstyle,
        token: isLogin ? user.token : "",
        type: "jewelry",
      };
      axios
        .post(base_url + "/order/add_to_cart", data, {
          headers: postHeader,
        })
        .then((res) => {
          if (res.data.status == 1) {
            store.dispatch(cartlengthvalue(res.data.data.total_count));
            this.props.history.push("/cart");
            toast.success(res.data.message, { autoClose: 3000 });
          } else if (res.data.status == 2) {
            localStorage.removeItem("bw-user");
            store.dispatch(whishlistlength());
            store.dispatch(cartlengthvalue(0));
            store.dispatch(sessionId(""));
            this.props.history.push("/");
            window.location.reload(true);
          } else {
            toast.error(res.data.message, { autoClose: 3000 });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  submitReview = () => {
    const data = {
      currency_code: currencycode,
      user_id: user?.user_id,
      token: user?.token,
      rating: this.state.rating,
      review: this.state.comment,
      product_id: this.state.productdetails?.product_id,
    };
    axios
      .post(base_url + "/product/add_review", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          this.getReview(data.product_id);
          this.setState({ review: false });
          this.setState({ comment: "", rating: "" });
        } else if (response.data.status == 2) {
          localStorage.removeItem("bw-user");
          store.dispatch(whishlistlength());
          store.dispatch(cartlengthvalue(0));
          store.dispatch(sessionId(""));
          this.props.history.push("/");
          window.location.reload(true);
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleShowInquiry = () => this.setState({ inquiry: true });
  handleCloseInquiry = () => this.setState({ inquiry: false });
  handleCloseShipping = () => this.setState({ shipping: false });
  handleShowShipping = () => this.setState({ shipping: true });
  handleCloseReturn = () => this.setState({ return: false });
  handleShowReturn = () => this.setState({ return: true });
  handleShowAppointment = () => this.setState({ appointment: true });
  handleCloseAppointment = () => this.setState({ appointment: false });
  handleCloseReview = () => this.setState({ review: false });
  handleShowReview = () => this.setState({ review: true });
  handleOpenButton = () => {
    if (this.state.ringSize == 0 && this.state.ringSizeAvailable) {
      this.setState({ notify: true });
      // setInterval(() => {  this.setState({ notify: false }) }, 3000);
    } else {
      this.setState({ openbutton: true });
    }
  };
  handleCloseButton = () => this.setState({ openbutton: false });

  setView = (event, index) => {
    this.setState({
      currentImageUrl: this.state.images[index].original,
      currentImagetype: this.state.images[index].type,
    });
  };
  selectSetting = () => {
    if (this.state.ringSize == 0 && this.state.ringSizeAvailable) {
      this.setState({ notify: true });
      // setInterval(() => {  this.setState({ notify: false }) }, 3000);
    } else {
      const data = {
        currency_code: currencycode,
        product_id: this.state.productdetails?.product_id,
        slug: this.state.productdetails?.slug,
        image: this.state.currentImageUrl,
        price: this.state.productdetails?.sale_price,
        ring_size: this.state.ringSize,
        name: this.state.productdetails?.name,
        engraving_text: this.state.engraving,
        engraving_font: this.state.textstyle,
      };
      localStorage.setItem(
        "bw-step",
        JSON.parse(localStorage.getItem("bw-gemstonedata") == null) &&
          JSON.parse(localStorage.getItem("bw-diamonddata") == null) &&
          JSON.parse(localStorage.getItem("bw-fancycolordata") == null)
          ? "setting"
          : "stone"
      );
      localStorage.setItem("bw-settingdata", JSON.stringify(data));
      if (JSON.parse(localStorage.getItem("bw-gemstonedata") != null)) {
        this.props.history.push("/complete-gemstone-ring");
      } else if (JSON.parse(localStorage.getItem("bw-diamonddata") != null)) {
        this.props.history.push("/complete-diamond-ring");
      } else if (
        JSON.parse(localStorage.getItem("bw-fancycolordata") != null)
      ) {
        this.props.history.push("/complete-fancycolor-ring");
      }
    }
  };
  engravingfunc = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    var settings2 = {
      dots: false,
      infinite: true,
      speed: 500,
      accessibility: true,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      centerPadding: "60px",
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    var average = 0;
    const average1 = this.state.reviewdata?.rating_count?.map((val) =>
      val.rating == 5 ? (average = val.average) : ""
    );
    const step = JSON.parse(sessionStorage.getItem("bw-step"))
      ? JSON.parse(sessionStorage.getItem("bw-step"))
      : [3, 1];
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.state.productdetails?.meta_title}</title>
          <meta
            name="description"
            content={this.state.productdetails?.meta_desp}
          ></meta>
          <meta
            name="keywords"
            content={this.state.productdetails?.meta_keywords}
          ></meta>
        </Helmet>
        {this.state.loader ? (
          <div className="rcs_filter_wrapper">
            {this.props.match.params.id == "setting" ? (
              <CircularProgress className="rcs_filter_loader rcs_filter_loader1" />
            ) : (
              <CircularProgress className="rcs_filter_loader" />
            )}
          </div>
        ) : (
          ""
        )}
        <div className="rcs_ringsetting_section mt-3">
          <Container
            className={
              this.props.match.params.id == "setting"
                ? "rcs_shap-wizard_container"
                : ""
            }
          >
            <Row>
              <Col className="rcs_breadcrumb mb-2">
                <Breadcrumbs aria-label="breadcrumb">
                  <NavLink underline="hover" color="inherit" to="/">
                    Home
                  </NavLink>
                  <NavLink
                    underline="hover"
                    color="inherit"
                    to={
                      this.props.match.params.id == "setting"
                        ? (step == JSON.stringify(step)) == "[2,3]" ||
                          JSON.stringify(step) == "[3,2]"
                          ? "/ringsettings/gemstones"
                          : JSON.stringify(step) == "[0,3]" ||
                            JSON.stringify(step) == "[3,0]"
                          ? "/ringsettings/fancycolor"
                          : "/ringsettings/diamonds"
                        : "/jewelry/" + this.state.productdetails?.category_slug
                    }
                  >
                    {this.state.productdetails.category_name}
                  </NavLink>
                  <Typography color="text.primary">
                    {this.state.productdetails.name}
                  </Typography>
                </Breadcrumbs>
              </Col>
            </Row>
          </Container>
          <Container className="rcs_shap-wizard_container">
            {this.props.match.params.id == "setting" ? (
              <Ringbildermenu location="setting" />
            ) : (
              ""
            )}
          </Container>
        </div>
        <div className="rcs_product_details">
          <Container>
            <Row>
              <Col sm={12} md={12} lg={8} xl={8} className="rcs_large_tablet">
                <div className="magnify-Image">
                {
                      console.log("dd23",this.state.images)
                    }
                  {/* <Row className="align-items-center"> */}
                  <Row>
                    <Col sm={2} className="order-last order-sm-first">
                   
                      <ImageGallery
                        originalAlt={this.state?.name}
                        thumbnailAlt={this.state?.name}
                        items={this.state.images}
                        onThumbnailClick={this.setView}
                        showFullscreenButton={false}
                        showPlayButton={false}
                        showNav={false}
                      />
                      {/* {this.state.videos?.map((val,index) => 
                                            <button onClick={(e)=> this.setViewvideo(e,index)} type="button" className= {this.state.currentImagetype == 1 ? "image-gallery-thumbnail " : "image-gallery-thumbnail active"}>
                                                <span class="image-gallery-thumbnail-inner">
                                                    <video class="image-gallery-thumbnail-image" src={Videoimg} />
                                                        </span>
                                                        </button> 
                                            )} */}
                    </Col>

                    <Col sm={10}>
                      {this.state.currentImagetype == 1 ? (
                        <SideBySideMagnifier
                          alwaysInPlace={false}
                          className="image-to-magnify"
                          fillAvailableSpace={false}
                          imageSrc={this.state.currentImageUrl}
                          largeImageSrc={this.state.currentImageUrl}
                        />
                      ) : this.state.currentImagetype == 3 ? <div class="video-wrapper">
                      <iframe 
                          src={this.state.currentImageUrl+"?rel=0"}
                          title="YouTube video player" 
                          frameborder="0" 
                          allowfullscreen>
                      </iframe>
                  </div>
                   : (
                        <div className="video-wrapper">
                          <video
                            width="540"
                            height="540"
                            src={this.state.currentImageUrl}
                            frameBorder="0"
                            allowFullScreen
                            playsinline="true"
                            autoPlay="true"
                            loop
                          ></video>
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col sm={12} md={12} lg={4} xl={4} className="rcs_large_tablet">
                <div className="ml_product_content d-flex widget flex-column justify-content-center align-items-start text-left pt-3 pt-md-0 w-100 widget h-100">
                  {this.state.loader ? (
                    <div className="rcs_content_block w-100">
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={290}
                          height={45}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={500}
                          height={45}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={350}
                          height={45}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={100}
                          height={30}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={100}
                          height={30}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={210}
                          height={30}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          width={150}
                          height={30}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={80}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={500}
                          height={100}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={130}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {isMobileOnly ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={290}
                          height={40}
                        />
                      ) : isTablet ? (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={690}
                          height={40}
                        />
                      ) : (
                        <Skeleton
                          variant="text"
                          animation="wave"
                          style={{ transform: "unset", marginTop: "10px" }}
                          width={350}
                          height={50}
                        />
                      )}
                      {/* <div className="rcs_product_btn">
                                                <ul className='d-flex justify-content-between'>
                                                    <li>{isMobileOnly ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={135} height={35} /> : isTablet ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={340} height={40} /> : <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={165} height={35} />}</li>
                                                    <li>{isMobileOnly ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={135} height={35} /> : isTablet ? <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px' }} width={340} height={40} /> : <Skeleton variant="text" animation="wave" style={{ transform: 'unset', marginTop: '10px', marginBottom: '5px' }} width={165} height={35} />}</li>
                                                </ul>
                                            </div> */}
                      <div className="rcs_social">
                        <ul>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                          <li>
                            {isMobileOnly ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                style={{
                                  transform: "unset",
                                  marginTop: "10px",
                                }}
                                width={65}
                                height={30}
                              />
                            ) : isTablet ? (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={170}
                                height={40}
                              />
                            ) : (
                              <Skeleton
                                variant="text"
                                animation="wave"
                                width={80}
                                height={30}
                              />
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : (
                    <div className="rcs_content_block w-100">
                      <div className="rcs_product_heading">
                        <h1>{this.state.productdetails?.name}</h1>
                      </div>
                      <div className="rcs_price">
                        <p>
                          <strong>SKU :</strong>{" "}
                          {this.state.productdetails?.sku}
                        </p>
                      </div>
                      {this.state.productdetails.is_price == 1 ? (
                        <div className="rcs_price">
                          <h4>
                            {this.state.productdetails?.actual_sale_price &&
                            Number(
                              this.state.productdetails?.actual_sale_price
                            ) > this.state.productdetails?.sale_price ? (
                              <>
                                <del>
                                  {this.state.productdetails?.currency_icon +
                                    this.state.productdetails
                                      ?.actual_sale_price}
                                </del>{" "}
                                <span>
                                  {this.state.productdetails?.currency_icon +
                                    this.state.productdetails?.sale_price}
                                </span>{" "}
                                <span className="saveNPercent">
                                  Save{" "}
                                  {this.calculateDiscount(
                                    this.state.productdetails
                                      ?.actual_sale_price,
                                    this.state.productdetails?.sale_price
                                  )}
                                  %
                                </span>
                              </>
                            ) : (
                              this.state.productdetails?.currency_icon +
                              this.state.productdetails?.sale_price
                            )}
                          </h4>
                        </div>
                      ) : (
                        <div className="rcs_email">
                          <span>Email us for Price</span>
                        </div>
                      )}
                      <div className="rcs_content_details">
                        <p>{this.state.productdetails?.description}</p>
                      </div>
                      <div className="rcs_filter rcs_add_address">
                        {this.state.filterdata?.map((val) => (
                          <FormControl variant="outlined">
                            <InputLabel
                              className={
                                val?.title == "Ring Size" && this.state.notify
                                  ? "rcs_details_ring_size1"
                                  : ""
                              }
                              id="demo-simple-select-outlined-label"
                            >
                              {val?.title}
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={
                                val?.title == "Ring Size"
                                  ? this.state.ringSize == "0"
                                    ? ""
                                    : this.state.ringSize
                                  : val?.selected
                              }
                              onChange={(e) => {
                                this.setState({ notify: false });
                                val?.title == "Ring Size"
                                  ? this.setState({ ringSize: e.target.value })
                                  : this.onchangeselect(e, val?.title);
                              }}
                              label={val?.title}
                              className={
                                val?.title == "Ring Size" && this.state.notify
                                  ? "rcs_details_ring_size animate__animated animate__shakeX"
                                  : "rcs_details_ring_size"
                              }
                            >
                              {val?.data?.map((option) => (
                                <MenuItem value={option.value}>
                                  {option.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        ))}
                      </div>
                      <div className="rcs_product_btn">
                        {this.state.productdetails?.enable_ecommerce == 1 ? (
                          this.props.match.params.id == "setting" ? (
                            JSON.parse(
                              localStorage.getItem("bw-gemstonedata") != null
                            ) ||
                            JSON.parse(
                              localStorage.getItem("bw-diamonddata") != null
                            ) ||
                            JSON.parse(
                              localStorage.getItem("bw-fancycolordata") != null
                            ) ? (
                              <Button aria-label="Add This Setting"
                                variant="contained"
                                onClick={() => this.selectSetting()}
                                className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                              >
                                Add This Setting
                              </Button>
                            ) : (
                              <Button aria-label="Add This Setting"
                                variant="contained"
                                onClick={() => this.handleOpenButton()}
                                className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                              >
                                Add This Setting
                              </Button>
                            )
                          ) : (
                            <Button aria-label="Add to Cart"
                              variant="contained"
                              onClick={() =>
                                this.addtocart(
                                  this.state.productdetails?.product_id,
                                  1
                                )
                              }
                              className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                            >
                              Add to Cart
                            </Button>
                          )
                        ) : (
                          <Button aria-label="Inquire"
                            variant="contained"
                            className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                            onClick={() => this.handleShowInquiry()}
                          >
                            Inquire
                          </Button>
                        )}
                        <Dialog
                          onClose={this.handleCloseButton}
                          open={this.state.openbutton}
                          className="rcs_dialog_btn1"
                        >
                          <List sx={{ pt: 0 }} className="rcs_dialog_btn m-10">
                            <Button aria-label="ADD A DIAMOND"
                              variant="contained"
                              onClick={() => {
                                this.props.history.push("/diamonds");
                                this.handleCloseButton();
                                this.selectSetting();
                              }}
                              className="rcs_add_setting_btn w-100 mb-3"
                            >
                              ADD A DIAMOND
                            </Button>
                            <Button aria-label="ADD A GEMSTONE"
                              variant="contained"
                              onClick={() => {
                                this.props.history.push("/gemstones");
                                this.handleCloseButton();
                                this.selectSetting();
                              }}
                              className="rcs_add_setting_btn1 w-100 mb-3"
                            >
                              ADD A GEMSTONE
                            </Button>
                            <Button aria-label="ADD A FANCY DIAMOND"
                              variant="contained"
                              onClick={() => {
                                this.props.history.push("/fancy-color-diamond");
                                this.handleCloseButton();
                                this.selectSetting();
                              }}
                              className="rcs_add_setting_btn2 w-100 mb-3"
                            >
                              ADD A FANCY DIAMOND
                            </Button>
                            <Button aria-label="ADD TO CART"
                              variant="contained"
                              onClick={() => {
                                this.addtocart(
                                  this.state.productdetails?.product_id,
                                  1
                                );
                                this.handleCloseButton();
                                this.selectSetting();
                              }}
                              className="rcs_add_setting_btn2 w-100 mb-3"
                            >
                              ADD TO CART
                            </Button>
                          </List>
                        </Dialog>
                        {this.state.productdetails?.is_wishlist == 0 ? (
                          <Button aria-label="Add to Wish List"
                            variant="outlined"
                            onClick={() =>
                              this.addtowishlist(
                                this.state.productdetails?.product_id
                              )
                            }
                            className="rcs_border_btn w-100 mb-3 rcs_wish_btn_detail"
                          >
                            Add to Wish List
                          </Button>
                        ) : (
                          <ul>
                            <li>
                              <Button aria-label="Remove From Wish List"
                                onClick={() =>
                                  this.addtowishlist(
                                    this.state.productdetails?.product_id
                                  )
                                }
                                variant="outlined"
                                className="rcs_border_btn rcs_border_btn2 w-100 mb-3 float-left mr-1 rcs_wish_btn_detail"
                              >
                                Remove From Wish List
                              </Button>
                            </li>
                            {/* <li><Button variant="outlined" onClick={() => isLogin ? this.props.history.push('/account/wishlist') : this.props.history.push('/wishlist')} className="rcs_border_btn rcs_border_btn3 mb-3 ml-1">View Wish List</Button></li> */}
                          </ul>
                        )}
                        <Button aria-label="Schedule an Appointment"
                          variant="outlined"
                          className="rcs_border_btn w-100 mb-3 rcs_appoint_btn_detail"
                          onClick={this.handleShowAppointment}
                        >
                          Schedule an Appointment
                        </Button>
                        {/* <ul>
                                                    <li><Button variant="outlined" className="rcs_border_btn rcs_border_btn1 mb-3 float-left mr-1 rcs_border_btn_border" onClick={this.handleShowShipping}> <i class="fas fa-shipping-fast"></i> Shipping</Button></li>
                                                    <li><Button variant="outlined" className="rcs_border_btn rcs_border_btn1 mb-3 ml-1 rcs_border_btn_border" onClick={this.handleShowReturn}> <i class="fas fa-undo-alt"></i> Returns</Button></li>
                                                </ul> */}
                      </div>
                      {/* <div className="rcs_ring_style_type">
                                            {this.state.productdetails?.attribute?.map(val =>
                                                val.title.includes('Style') ?
                                                    <p><strong>{val.title} : </strong>{val.value}</p> : ""
                                            )}
                                        </div> */}

                      {this.state.productdetails?.enable_engraving == 1 ? (
                        <Button aria-label="Free Engraving"
                          className="gs_save_btn rcs_border_btn w-100 mb-3"
                          onClick={() =>
                            this.setState({
                              engravingshow: !this.state.engravingshow,
                            })
                          }
                        >
                          {this.state.engravingshow ? (
                            <>
                              {" "}
                              Free Engraving{" "}
                              <RemoveCircleIcon className="ml-1" />{" "}
                            </>
                          ) : (
                            <>
                              {" "}
                              Free Engraving <AddCircleIcon className="ml-1" />
                            </>
                          )}
                        </Button>
                      ) : (
                        ""
                      )}
                      {this.state.engravingshow ? (
                        <div className="gs_engraving">
                          <div className="gs_engraving_text">
                            <div className="wrapper">
                              {this.state.MetalColor?.includes("Rose-Gold") ? (
                                <Image src={rose_metal} alt="engraving"></Image>
                              ) : this.state.MetalColor?.includes(
                                  "Yellow-Gold"
                                ) ? (
                                <Image
                                  src={yellow_metal}
                                  alt="engraving"
                                ></Image>
                              ) : (
                                <Image
                                  src={white_metal}
                                  alt="engraving"
                                ></Image>
                              )}
                              <Engraving
                                text={this.state.engraving}
                                arc={100}
                                radius={200}
                                cname={
                                  this.state.textstyle == "great_vibes"
                                    ? "gs_great_vibes"
                                    : "gs_montserrat"
                                }
                              />
                            </div>
                          </div>
                          <Row className="w-100 m-auto gs_engraving_input">
                            <Col className="p-0">
                              <TextField
                                className={
                                  this.state.eng_color &&
                                  this.state.engraving?.length
                                    ? "eng_color_fill"
                                    : "eng_color_none"
                                }
                                id="outlined-basic"
                                label="Engraving"
                                type="text"
                                variant="outlined"
                                autoComplete="off"
                                name="engraving"
                                onBlurCapture={() =>
                                  this.setState({ eng_color: true })
                                }
                                value={this.state.engraving}
                                onChange={(e) => this.engravingfunc(e)}
                                inputProps={{
                                  maxLength: 15,
                                }}
                              />
                              {this.state.engraving?.length ? (
                                <p className="eng_sub_lbl d-flex">
                                  <CheckCircleIcon /> "{this.state.engraving}"
                                  has been added to your engraving.{" "}
                                </p>
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                          <Row className="w-100 m-auto">
                            <Col className="p-0">
                              <div className="gs_engraving_text2">
                                <ul>
                                  <li
                                    onClick={() =>
                                      this.setState({
                                        textstyle: "great_vibes",
                                      })
                                    }
                                    className={
                                      this.state.textstyle == "great_vibes"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span class="gs_great_vibes">Aa</span>
                                  </li>
                                  <li
                                    onClick={() =>
                                      this.setState({ textstyle: "montserrat" })
                                    }
                                    className={
                                      this.state.textstyle == "montserrat"
                                        ? "active"
                                        : ""
                                    }
                                  >
                                    <span class="gs_montserrat">Aa</span>
                                  </li>
                                </ul>
                              </div>
                              {/* <p className="mt-3">Engraved Items are now eligible for exchange and returns</p> */}
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        //  localStorage.getItem('engravingtext')?.length && this.state.productdata?.is_engraving == 1 ? <div className="gs_engraving">
                        //     <div className="gs_engraving_text1">
                        //         <Row>
                        //             <Col xs={8} sm={6} lg={10} >
                        //                 <h2><span class={this.state.textstyle == 'great_vibes' ? "gs_great_vibes gs_great_mob" : "gs_montserrat gs_great_mob"}>{localStorage.getItem('engravingtext')}</span> <span className="icon"><CheckCircleIcon /></span></h2>
                        //             </Col>
                        //             <Col xs={4} sm={6} lg={2}>
                        //                 <p onClick={() => { this.setState({ engravingtext: "" }); localStorage.setItem("engravingtext", "") }}> <DeleteIcon className="eng_del_icon" /></p>
                        //             </Col>
                        //         </Row>
                        //     </div>
                        // </div> :
                        ""
                      )}
                      <div className="rcs_social">
                        <ul>
                          <li>
                            <FacebookShareButton
                              url={String(window.location)}
                              className="Demo__some-network__share-button"
                            >
                              <i class="fab fa-facebook-f"></i> Facebook
                            </FacebookShareButton>
                          </li>
                          <li>
                            <PinterestShareButton
                              url={String(window.location)}
                              media={String(window.location)}
                              windowWidth={1000}
                              windowHeight={730}
                            >
                              <i class="fab fa-pinterest-p"></i> Pinterest
                            </PinterestShareButton>{" "}
                          </li>
                          <li>
                            <EmailShareButton
                              subject={client_name.c_name}
                              body={String(window.location)}
                            >
                              <i class="fas fa-envelope"></i> Email
                            </EmailShareButton>{" "}
                          </li>
                          <li>
                            <TwitterShareButton
                              title={client_name.c_name}
                              url={String(window.location)}
                            >
                              <i class="fab fa-twitter"></i> Twitter
                            </TwitterShareButton>{" "}
                          </li>
                        </ul>
                      </div>
                      <div className="mt-4 ali_pro_note_box text-left">
                        <strong>Note:</strong>
                        <ul
                          style={{ listStyleType: "disc", paddingLeft: "15px" }}
                        >
                          <li style={{}}>
                            {" "}
                            To request any alterations to our products, please
                            contact our Diamond/Jewelry consultant at{" "}
                            <a
                              href="mailto:service@aliciasjewelers.com"
                              className="text-dark text-decoration-underline"
                            >
                              service@aliciasjewelers.com
                            </a>
                            .
                          </li>
                          <li>
                            Delivery timeline typically spans 10 to 12 days.
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="rcs_product_specification">
          <Container>
            <Row className="m-auto w-100">
              <Col className="p-0">
                <h2>PRODUCT DETAILS</h2>
                <Row>
                  {this.state.productdetails?.attribute?.map((val) => (
                    <Col xs={6} sm={3}>
                      <div className="rcs_product_specification_content">
                        <strong>{val.title} : </strong>
                        <p>{val.value}</p>
                      </div>
                    </Col>
                  ))}
                  {this.state.productdetails?.category_id == "2" ? (
                    <Col xs={6} sm={3}>
                      <div className="rcs_product_specification_content">
                        <strong>Can be set with : </strong>
                        <p>
                          {this.state.productdetails?.setwithmin +
                            " - " +
                            this.state.productdetails?.setwithmax}
                        </p>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <section className="rcs_related_product_section">
          <Container>
            <Row>
              <Col lg={12} sm={12}>
                <div className="rcs_related_product_title">
                  <h3>You Might Also Like </h3>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg={12} sm={12} className="pr-0">
                <div className="rcs_customer_review_slider">
                  <Slider
                    className="rcs_customer_say_inner rcs_product_grid"
                    {...settings2}
                  >
                    {this.state.listdata?.map((val, index) => (
                      <div className="mg_nopadd">
                        <div className="rcs_product_item position-relative">
                          <div class="d-flex  hover-buttons justify-content-between">
                            {val.enable_ecommerce == 1 ? (
                              <span
                                onClick={() => this.addtocart(val.product_id)}
                              >
                                {" "}
                                <img src={cart} alt="cart" />{" "}
                              </span>
                            ) : (
                              <span
                                onClick={() => {
                                  this.setState({ product_id: val.product_id });
                                  this.handleShowInquiry(true);
                                }}
                              >
                                {" "}
                                <img src={inquir} alt="cart" />{" "}
                              </span>
                            )}
                            {/* <span onClick={() => quickopen(val)}> <Image src={eye} />  </span> */}
                          </div>
                          <NavLink
                            to="#"
                            onMouseOver={() =>
                              this.setState({ proindex: index + 1 })
                            }
                            onMouseLeave={() => this.setState({ proindex: "" })}
                            onClick={() =>
                              this.setState({ slug: val.slug, filterdata: [] })
                            }
                          >
                            <div class="color-overlay"></div>
                            {val.product_image?.length > 1 ? (
                              <>
                                <div>
                                  {this.state.proindex == index + 1 ? (
                                    <img
                                      src={val.product_image[1].url}
                                      alt="cart"
                                    />
                                  ) : (
                                    <img
                                      src={val.product_image[0].url}
                                      alt="cart"
                                    />
                                  )}
                                </div>
                              </>
                            ) : (
                              <img
                                src={val.product_image[0].url}
                                alt="cart"
                              ></img>
                            )}
                          </NavLink>
                          <div className="rcs_prod_info d_space_between">
                            <div className="d-flex align-items-start pt-10">
                              <h2
                                onClick={() =>
                                  this.setState({
                                    slug: val.slug,
                                    filterdata: [],
                                  })
                                }
                                className="rcs_list_title"
                              >
                                {val.name}
                              </h2>
                              <button
                                class="rcs_wish_btn rcs_wish_btn_desktop"
                                value="button"
                                aria-label="wishlist"
                              >
                                {val.is_wishlist == "0" ? (
                                  <FavoriteBorderIcon
                                    onClick={() =>
                                      this.addtowishlist(
                                        val.product_id,
                                        index,
                                        1
                                      )
                                    }
                                  />
                                ) : (
                                  <FavoriteIcon
                                    onClick={() =>
                                      this.addtowishlist(
                                        val.product_id,
                                        index,
                                        1
                                      )
                                    }
                                    className="animate__animated animate__heartBeat"
                                  />
                                )}
                              </button>
                            </div>
                            <p className="rcs_emailprice">
                              {val.is_price == 1
                                ? val.currency_icon + val.sale_price
                                : "Email us for Price"}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <div className="rcs_product_specification">
          {this.state.reviewdata?.rating_count?.length ? (
            <div className="rcs_product_specification_top">
              <Container>
                <Row className="m-auto w-100">
                  <Col className="rcs_p0">
                    <h2>REVIEWS</h2>
                    <Row>
                      <Col xs={12} sm={6} md={7} className="rcs_p0 p-0">
                        <div className="rcs_rating_overall">
                          <h2>{this.state.reviewdata?.average_rating}</h2>
                          <p className="rcs_out_of">Out of 5</p>
                        </div>
                        <div className="rcs_rating_progress">
                          <ul>
                            {this.state.reviewdata?.rating_count?.map((val) => (
                              <li>
                                <p>{val.rating} Star</p>{" "}
                                <ProgressBar
                                  className="w-75"
                                  now={val.average}
                                />
                                <span>{val.count}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Col>
                      <Col xs={12} sm={6} md={5} className="p-0">
                        <div className="rcs_rating_overall_star">
                          <h3>Overall Rating</h3>
                          <Rating
                            name="read-only"
                            value={Number(
                              this.state.reviewdata?.average_rating
                            )?.toFixed(0)}
                            readOnly
                          />
                        </div>
                        <div className="rcs_rating_overall_total">
                          <h3>{average}%</h3>
                          <p>
                            of recent buyers <br />
                            gave {client_name.c_name} 5 stars
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </div>
          ) : (
            ""
          )}
          <div className="rcs_product_specification_bottom pb-5">
            <Container className="rcs_p0 mt-4">
              {this.state.reviewdata?.review_data?.map((val) => (
                <Row className="m-auto w-100">
                  <Col className="p-0">
                    <div className="rcs_product_specification_bottom_content">
                      <div className="media">
                        <div className="rcs_test_cotnent">
                          <span className="rcs_user_name">
                            {val.first_name[0]}
                          </span>
                        </div>
                        <div class="media-body">
                          <label class="mb-0">
                            {val.first_name} {val.last_name}
                          </label>
                          <p class="colored-stars">
                            <Rating
                              name="read-only"
                              value={val.rating}
                              readOnly
                            />
                            <small class="float-right">
                              {moment(new Date(val.created_at)).format(
                                "YYYY-MM-DD"
                              )}
                            </small>
                          </p>
                          <p class="pt-2 pr-md-30 mb-0 small">{val.review}</p>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              ))}
              <Row className="m-auto w-100 rcs_write_review">
                <Col className="p-0">
                  <h2>SUBMIT A PRODUCT REVIEW</h2>
                  <Button aria-label="Write a Review"
                    variant="contained"
                    className="rcs_acc_button rcs_review_btn"
                    onClick={() =>
                      isLogin
                        ? this.handleShowReview()
                        : document.getElementById("loginbutton")?.click()
                    }
                  >
                    Write a Review
                  </Button>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/*Shipping Modal*/}
        {this.state.shipping ? (
          <ShippingModal
            shippingterm={this.state.shippingterm}
            handleCloseShipping={this.handleCloseShipping}
          />
        ) : (
          ""
        )}
        {/*Shipping Modal*/}
        {/*Inquiry Modal*/}
        {this.state.inquiry ? (
          <ProductEnquiry
            productid={this.state.productdetails?.product_id}
            handleCloseInquiry={this.handleCloseInquiry}
          />
        ) : (
          ""
        )}
        {/*Inquiry Modal*/}
        {/*Return Modal*/}
        {this.state.return ? (
          <ReturnModal handleCloseReturn={this.handleCloseReturn} />
        ) : (
          ""
        )}
        {/*Return Modal*/}
        {/*Review Modal*/}
        <Modal show={this.state.review} onHide={this.handleCloseReview}>
          <Modal.Header>
            <Modal.Title>WRITE A REVIEW</Modal.Title>
            <button aria-label="close"
              type="button"
              onClick={this.handleCloseReview}
              class="close"
            >
              <span aria-hidden="true">×</span>
              <span class="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="rcs_add_address">
              <Row>
                <Col>
                  <p>
                    Enter your information below and tell us about your
                    experience.
                  </p>
                </Col>
              </Row>
              <Form>
                <Row>
                  <Col xs={12}>
                    <TextField
                      id="outlined-select-currency"
                      select
                      label="Rating"
                      value={this.state.rating}
                      onChange={(e) =>
                        this.setState({ rating: e.target.value })
                      }
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                    </TextField>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <TextField
                      id="outlined-basic"
                      multiline
                      rows={4}
                      label="Testimonial"
                      type="text"
                      variant="outlined"
                      value={this.state.comment}
                      onChange={(e) =>
                        this.setState({ comment: e.target.value })
                      }
                      required
                    />
                  </Col>
                </Row>
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button aria-label="close"
              variant="secondary"
              className="rcs_cancel_button mr-2"
              onClick={this.handleCloseReview}
            >
              Close
            </Button>
            <Button aria-label="Submit Testimonial"
              variant="primary"
              className="rcs_save_button"
              onClick={() => this.submitReview()}
            >
              Submit Testimonial
            </Button>
          </Modal.Footer>
        </Modal>
        {/*Review Modal*/}
        {/*Appointment Modal*/}
        {this.state.appointment ? (
          <ProductAppoitnment
            type="jewelry"
            id={this.state.productdetails?.product_id}
            handleClose={() => this.setState({ appointment: false })}
          />
        ) : (
          ""
        )}
        {/*Appointment Modal*/}
      </>
    );
  }
}

export default Productdetails;
